import { pick, prop } from 'ramda';
import { useEffect } from 'react';
import { useGameConfigurationSelector, useUserSelector } from 'js/store/hooks';

import * as helpers from '../helpers';
import * as actions from '../store/actions';
import { useDynamicReducerDispatch } from '../store';

export const useFavoritesSubscription = () => {
    const dispatch = useDynamicReducerDispatch();
    const { isInternalPlayer } = useUserSelector(prop('userDetails'));
    const { games: allGames, favoriteGames = [] } = useGameConfigurationSelector(pick(['games', 'favoriteGames']));

    useEffect(() => {
        const filteredGames = helpers.filterGamesByAvailability({
            allGames,
            isInternalPlayer,
            gameCodes: favoriteGames
        });

        dispatch(actions.updateFavoriteGames(filteredGames));
    }, [allGames, dispatch, favoriteGames, isInternalPlayer]);
};
